import React from 'react'
import YouTubeVideoWithThumbnail from './FacadeVideo'
import Reveal from './Reveal'

const VideoFlexGrid = ({ mediaItems }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {mediaItems.map((item, index) => {
        const media =
          item.type === 'video' ? (
            <YouTubeVideoWithThumbnail videoId={item.url} title={item.title} />
          ) : item.type === 'link' ? (
            <a
              href="https://souslesdraps.org/"
              target="_blank"
              rel="noreferrer"
              className="block w-full h-full group"
              aria-label={`${item.title} — ouvrir souslesdraps.org dans un nouvel onglet`}
            >
              <img
                className="object-contain w-full h-full transition-transform duration-700 group-hover:scale-105"
                src={item.url}
                alt={item.title}
              />
            </a>
          ) : (
            <img className="object-contain w-full h-full" src={item.url} alt={item.title} />
          )

        return (
          <Reveal key={index} delay={(index % 3) * 90}>
            <figure className="group card-surface ring-gradient rounded-2xl overflow-hidden flex flex-col transition-transform duration-500 hover:-translate-y-1.5">
              {/* Zone média : ratio 16:9 garanti via padding-top (56.25%) + contenu
                  ancré en absolute inset-0 => hauteur stable, média toujours visible
                  en entier, cartes strictement égales quel que soit le contenu. */}
              <div className="relative w-full overflow-hidden bg-[#07021a]" style={{ paddingTop: '56.25%' }}>
                <div className="absolute inset-0">{media}</div>
              </div>
              {/* Légende : hauteur fixe => toutes les cartes identiques */}
              <figcaption className="flex items-center px-5 h-[4.5rem] text-sm text-[#cbbef0] leading-snug line-clamp-2">
                {item.title}
              </figcaption>
            </figure>
          </Reveal>
        )
      })}
    </div>
  )
}

export default VideoFlexGrid
